// @flow
import * as React from 'react';
import BusyIndicator from '../Common/BusyIndicator';
import NetworkErrorPage from '../Routing/NetworkErrorPage';
import api from '../../services/api';
import transformHealthCheckData from '../../utils/dataTransformations/transformHealthCheckData';

class HealthCheck extends React.Component<
  {
    children: React.Node
  },
  {
    busy: boolean,
    errors: Array<string>
  }
> {
  state = {
    busy: true,
    errors: []
  };

  componentDidMount() {
    api.health
      .get()
      .then(() => this.setState({ busy: false }))
      .catch(error => {
        if (error.response) {
          const { status, data } = error.response;

          if (status === 503 && data) {
            this.setState({
              errors: transformHealthCheckData(data),
              busy: false
            });

            return;
          }
        }

        this.setState({
          busy: false,
          errors: ['Network Error']
        });
      });
  }

  render() {
    if (this.state.busy) {
      return <BusyIndicator text="Connecting to server" size="5x" />;
    }

    if (this.state.errors.length) {
      return <NetworkErrorPage errors={this.state.errors} />;
    }

    return <>{this.props.children}</>;
  }
}

export default HealthCheck;
